import { Controller } from '@hotwired/stimulus'

/**
 * Controls print and close actions for print layout pages.
 * Replaces inline onclick handlers with Stimulus controller.
 *
 * Usage:
 *   <div data-controller="print-window">
 *     <button data-action="click->print-window#close">Close</button>
 *     <button data-action="click->print-window#print">Print</button>
 *   </div>
 */
export default class extends Controller {
  close() {
    window.close()
  }

  print() {
    window.print()
  }
}
